import * as semver from 'semver'

// From v2.9.0 on, 1155 tokens (free and paid mints) and preminted tokens
// use dynamic mint fee and percentage based rewards
export const contractSupportsDynamicMintFee = (
  contractVersion?: string | null,
  contractStandard?: 'ERC721' | 'ERC1155'
) => {
  if (!contractStandard || !contractVersion) {
    return false
  }

  // Try force-convert version format to semver format
  const semVerContractVersion = semver.coerce(contractVersion)?.raw
  if (!semVerContractVersion) return false

  if (contractStandard === 'ERC1155') {
    return semver.gte(semVerContractVersion, '2.9.0')
  } else {
    // 721s use the hardcoded mint fee
    return false
  }
}
